/**
 * @generated SignedSource<<a2f1fb017cf204bc3e2e85149c2195e0>>
 * @relayHash 43e22200d20c9054da6f6b002b467f53
 * @lightSyntaxTransform
 * @nogrep
 * @codegen-command: yarn relay
 */

/* tslint:disable */
/* eslint-disable */
// @ts-nocheck

// @relayRequestID 3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97

import type { ConcreteRequest } from 'relay-runtime';
export type PublicLinkPageStatus = "BLOCKED_BY_CLASSIFICATION_LEVEL" | "BLOCKED_BY_CONTAINER_POLICY" | "BLOCKED_BY_ORG" | "BLOCKED_BY_ORG_DEFAULT_POLICY" | "BLOCKED_BY_PRODUCT" | "BLOCKED_BY_SPACE" | "OFF" | "ON" | "SITE_BLOCKED" | "SITE_DISABLED" | "SPACE_BLOCKED" | "SPACE_DISABLED" | "TRASHED" | "%future added value";
export type useShareAndRestrictButtonDataQuery$variables = {
  contentId: string;
  isContentTypePublicLinkEligible: boolean;
};
export type useShareAndRestrictButtonDataQuery$data = {
  readonly publicLinkPage?: {
    readonly pageId: string;
    readonly pageStatus: PublicLinkPageStatus;
  } | null | undefined;
  readonly singleContent: {
    readonly hasInheritedRestrictions: boolean;
    readonly hasRestrictions: boolean;
    readonly hasViewRestrictions: boolean;
    readonly id: string | null | undefined;
    readonly title: string | null | undefined;
  } | null | undefined;
};
export type useShareAndRestrictButtonDataQuery = {
  response: useShareAndRestrictButtonDataQuery$data;
  variables: useShareAndRestrictButtonDataQuery$variables;
};

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "contentId"
  },
  {
    "defaultValue": null,
    "kind": "LocalArgument",
    "name": "isContentTypePublicLinkEligible"
  }
],
v1 = [
  {
    "args": [
      {
        "kind": "Variable",
        "name": "id",
        "variableName": "contentId"
      }
    ],
    "concreteType": "Content",
    "kind": "LinkedField",
    "name": "singleContent",
    "plural": false,
    "selections": [
      {
        "kind": "ScalarField",
        "name": "id"
      },
      {
        "kind": "ScalarField",
        "name": "hasInheritedRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "hasRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "hasViewRestrictions"
      },
      {
        "kind": "ScalarField",
        "name": "title"
      }
    ]
  },
  {
    "condition": "isContentTypePublicLinkEligible",
    "kind": "Condition",
    "passingValue": true,
    "selections": [
      {
        "args": [
          {
            "kind": "Variable",
            "name": "pageId",
            "variableName": "contentId"
          }
        ],
        "concreteType": "PublicLinkPage",
        "kind": "LinkedField",
        "name": "publicLinkPage",
        "plural": false,
        "selections": [
          {
            "kind": "ScalarField",
            "name": "pageId"
          },
          {
            "kind": "ScalarField",
            "name": "pageStatus"
          }
        ]
      }
    ]
  }
];
return {
  "fragment": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Fragment",
    "name": "useShareAndRestrictButtonDataQuery",
    "selections": (v1/*: any*/),
    "type": "Query"
  },
  "kind": "Request",
  "operation": {
    "argumentDefinitions": (v0/*: any*/),
    "kind": "Operation",
    "name": "useShareAndRestrictButtonDataQuery",
    "selections": (v1/*: any*/)
  },
  "params": {
    "cacheID": "43e22200d20c9054da6f6b002b467f53",
    "id": "3e62a6711347ebe24e07ec7b2626132ba0b382ac1b84769556e96431c837da97",
    "metadata": {},
    "name": "useShareAndRestrictButtonDataQuery",
    "operationKind": "query",
    "text": "query useShareAndRestrictButtonDataQuery($contentId:ID!,$isContentTypePublicLinkEligible:Boolean!){singleContent(id:$contentId){id,hasInheritedRestrictions,hasRestrictions,hasViewRestrictions,title},publicLinkPage(pageId:$contentId)@include(if:$isContentTypePublicLinkEligible){pageId,pageStatus}}"
  }
};
})();

(node as any).hash = "3f2ed67e9608ba74e2a432234c7f66f7";

export default node;
